// add lazy-load supported
import LazyLoad from "vanilla-lazyload";

function mobileNav(e) {
    var n = document.body, t = document.querySelectorAll(e), o = document.getElementById("mobile-casino--open"),
      l = document.getElementsByClassName(["mobile-casino--list"])[0],
      i = document.querySelectorAll(".mobile-casino--overly, .mobile-casino--close");
    if (o) {
        o.onclick = function() {
            n.classList.add("active-nav");
        };
    }
    for (var r = 0; r < i.length; r++) i[r].onclick = c;

    function c() {
        n.classList.remove("active-nav");
    }

    for (r = 0; r < t.length; r++) l.innerHTML += "<li class=\"mobile-casino--item\">" + t[r].innerHTML + "</li>", l.children[r].children[0].classList = "";
}

let myLazyLoad = new LazyLoad();

mobileNav('.header-nav--list li');

(function(){
    'use strict';
    //--------------------------------------------------------------------------------------------------------------
    //	LOAD IFRAME GAME
    //--------------------------------------------------------------------------------------------------------------
    (function(){
        var wrap = document.getElementById('js_game');
        if (wrap){
            loadGame();
        }

        function loadGame(){
            var btn = wrap.getElementsByTagName('button')[0];
            if (btn){
                btn.addEventListener('click', loadFrame);
            }

            function loadFrame(){
                var frame = document.createElement('iframe'),
                    src = wrap.getAttribute('data-game');

                frame.setAttribute('src', src);
                btn.removeEventListener('click', loadFrame);
                wrap.innerHTML = '';
                wrap.appendChild(frame);
            }
        }
    })();
})();


function up_button() {
    var n = document.createElement("span");

    function t() {
        var t = Date.now(), o = setInterval(function() {
            var e = Date.now() - t, n = window.pageYOffset || document.documentElement.scrollTop;
            5e3 <= e || n <= 0 ? clearInterval(o) : function(e, n, t) {
                if (0 < t) {
                    var o = t - t * e / (2 * n);
                    window.scrollTo(0, o);
                }
            }(e, 5e3, n);
        }, 10);
    }

    document.querySelector("body").appendChild(n), n.style.opacity = "0", n.className = "up_button", window.onscroll = function() {
        var e = window.pageYOffset || document.documentElement.scrollTop;
        .5 * window.innerHeight < e ? (n.style.opacity = "1", n.style.cursor = "pointer", n.addEventListener("click", t)) : (n.style.opacity = "0", n.style.cursor = "inherit", n.removeEventListener("click", t));
    };
}


up_button(),

//--------------------------------------------------------------------------------------------------------------
//	Bonus shortcode accordion button
//--------------------------------------------------------------------------------------------------------------
    jQuery('.action-open-btn').click(function() {
        jQuery(this).closest('.action-container').find('.action-action-container').slideToggle();
        if (jQuery(this).text() == 'Скрыть') {
            jQuery(this).text('Подробнее');
        } else {
            jQuery(this).text('Скрыть');
        }
        jQuery(this).toggleClass('actived');
    });

var startText = $(".js-bonus-button").html();
$(".js-bonus-button").on("click", function () {
    $(this).hasClass("remove") ? ($(this).removeClass("remove").html(startText), $(this).parent().next().slideUp()) : ($(".js-bonus-button").removeClass("remove").html(startText), $(this).html("Скрыть").addClass("remove"), $(".bonus-item__content").slideUp(), $(this).parent().next().slideDown())
});

// adapt table
function _coverTable() {
    var table = document.querySelectorAll('table');
    for (var i = table.length - 1; i >= 0; i--) {
        var cover = document.createElement('div');
        cover.classList.add('cover-table');
        table[i].parentNode.insertBefore(cover, table[i]);
        cover.appendChild(table[i]);
    }
}
_coverTable();

// adapt iframe
$(function(){
    $(document).ready(function () { iframeresize(); });
    $(window).resize(function () { iframeresize(); });

    function iframeresize(){
        $("iframe").each(function() {
            var width = $(this).width ();
            $(this).css("height", width / 1.4 + "px");
        });
    }
});
